import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import SignaturePad from 'signature_pad/dist/signature_pad.js';
// reactstrap components
import {
    Button,
    Modal,
    ModalBody,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

//function Visit() {
const MergeHN = (props) => {
    const [modalConsent, setModalConsent] = React.useState(false);
    const [showSign, setShowSign] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);
    const [clientWidth, setClientWidth] = useState(0);
    const [clientHeigh, setClientHeigh] = useState(0);
    const [canvas2, setCanvas] = useState(null);
    const [signPad, setSignPad] = useState(null);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [LineTrangskin, setLineTrangskin] = useState('');
    const [FullName, setFullName] = useState("");
    const [isMerge, setIsMerge] = useState(false);
    const [isCompleteData, setIsCompleteData] = useState(false);
    //const HN = (props.match.params.HN !== undefined) ? props.match.params.HN : null;

    const queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
    const params = new URLSearchParams(queryString);
    const hn = params.get('hn'); 

    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba' }
    const liff = window.liff;

    var canvas = null;
    var signaturePad = null;

    useEffect(() => {

        liff.init({
            liffId: '1654063801-QEM4xzPE'
        })
            .then(() => {
                if (liff.isLoggedIn()) {
                    liff.getProfile().then(function (profile) {
                        setLineTrangskin(profile.userId);

                        authenticationService.login(profile.userId, profile.userId)
                            .then(
                                user => {
                                    setIsMerge(true);
                                    setFullName(user.fullName);

                                    alert('คุณ ' + user.fullName +' เชื่อมต่อ Line OA แล้ว')
                                    setIsCompleteData(true);
                                    window.location.href = "https://lin.ee/m6KSajs/user/";

                                    if (user.isActive == 1) {
                                        
                                        
                                    }
                                    else {
                                        //const { from } = props.location.state || { from: { pathname: "/profile/" + _liffid } };
                                        // props.history.push(from);

                                        //Show Link ให้กรอกประวัติเพิ่ม
                                    }

                                    

                                },
                                error => {
                                    //const { from } = props.location.state || { from: { pathname: "/lineregister/" + _liffid } };
                                    //props.history.push(from);
                                }
                            );      



                    }).catch(function (error) {
                        //window.alert('Error getting profile: ' + error);
                    });
                }
                else {
   
                }

            })
            .catch((err) => {

            });




        setClientWidth(window.innerWidth);
        setClientHeigh(window.innerHeight);

        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };

    }, []);

    const handleSign = () => {
        canvas = document.getElementById("signature-pad");
        setCanvas(canvas);
        signaturePad = new SignaturePad(canvas);
        setSignPad(signaturePad);
    }
    const handleClear = () => {
        signPad.clear();
    }

    const handleSubmit = (evt) => {
        evt.preventDefault();
        setModalConsent(true);
    }


    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        const consent = canvas2.toDataURL();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
            body: JSON.stringify({
                "lineTrangskin": LineTrangskin,
                "hn": hn,
                "signBase64": consent
            })
        };

        fetch('/api/v1/identity/line-register', requestOptions)
            .then(response => response.json())
            .then(
                (result) => {
                    if (liff.isInClient()) {

                        if (result.isActive == 1) {
                            //setIsCompleteData(true);
                            window.location.href = "https://lin.ee/m6KSajs/user/";
                        }
                        else if (result.isActive == -1) {
                            setIcon("far fa-question-circle");
                            setModal2(false)
                            setErrMsg(result.message)
                            setModalError(true)
                        }
                        else {

                            //Redirect ให้กรอกประวัติเพิ่ม
                        }

                        /*
                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#registered'
                        }]).then(function () {
                            //window.alert('Message sent');
                            liff.closeWindow();
                        }).catch(function (error) {
                            alert('sending message: ' + error);
                            if (result.isActive == 1) {
                                //alert('ลงทะเบียนเรียบร้อยแล้ว HN ' + result.hn);
                                //liff.closeWindow();
                                //const { from } = props.location.state || { from: { pathname: "/tele" } };
                                //props.history.push(from);
                            }
                            else {
                                alert('ลงทะเบียนเรียบร้อยแล้ว กรุณากรอกข้อมูลเพิ่มเติม เพื่อเป็นประโยชน์ต่อการรักษา')
                                const { from } = props.location.state || { from: { pathname: "/profile/1654063801-PwXBy90W" } };
                                props.history.push(from);
                            }
                        });
                        */

                    } else {
                        alert("not client");
                    }

                },
                (error) => {
                    alert('fetch: ' + error);
                }
            )
    }

    return (
        <>
            <Modal style={{ margin: '.1rem' }} isOpen={modalConsent} toggle={() => setModalConsent(false)} backdrop={false} keyboard={false} onClosed={() => setShowSign(false)}
                onOpened={handleSign}
            >
                <div className="modal-header justify-content-center">
                    <button
                        className="close"
                        type="button"
                        onClick={() => setModalConsent(false)}
                    >
                        <i className="now-ui-icons ui-1_simple-remove"></i>
                    </button>
                    <h4 className="title title-up">{(!showSign ? "แบบยินยอมการรับบริการ" : "กรุณาลงลายมือชื่อเพื่อยินยอม")}</h4>
                </div>
                <ModalBody>
                    <p style={{ height: '380px', overflow: 'scroll', display: (!showSign ? "block" : "none") }}>
                        วัตถุประสงค์<br />
                        <br />1. เพื่อให้ประชาชน ผู้รับบริการ ทุกพื้นที่สามารถเข้าถึงบริการด้านการให้คำแนะนำด้านสุขภาพวินิจฉัยโรคเบื้องต้น
                      <br />2. เพื่อให้ประชาชนผู้รับบริการสามารถเข้าถึงและบริหารจัดการข้อมูลสุขภาพทางอิเล็กทรอนิกส์ของตนได้
                      <br />3. เพื่อให้ระบบสารสนเทศและบุคลากรที่ได้รับอนุญาตในการรักษาพยาบาลสามารถนำข้อมูลทางอิเล็กทรอนิกส์เพื่อการบริการสุขภาพไปใช้สำหรับการเข้ารับการรักษาของผู้รับบริการ และเป็นข้อมูลสำคัญประกอบการรักษา หรือในกรณีพิเศษอื่นๆ
                      <br />4. เพื่อนำออกเผยแพร่เพื่อเป็นสื่อด้านการศึกษา วิจัย ประชาสัมพันธ์ และพัฒนาระบบบริการทางการแพทย์ เพื่อประโยชน์ในทางราชการของกรมการแพทย์
  
                     <br /><br />ข้าพเจ้าได้รับการอธิบายถึงวัตถุประสงค์ คำชี้แจงปัญหา ข้อสงสัยในประเด็นต่าง ๆ รวมทั้งประโยชน์ และความเสี่ยงจะเกิดขึ้นอย่างละเอียดและเข้าใจดีแล้วในกรณียินยอม
                     <br /><br />โดยข้าพเจ้า ยินยอมให้โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้จังหวัดตรัง จัดเก็บข้อมูลส่วนบุคคล ข้อมูลด้านสุขภาพ การวินิจฉัยโรค การรักษา บันทึกภาพนิ่ง ภาพเคลื่อนไหว และเสียง เพื่อนำไปใช้ประโยชน์ตามวัตถุประสงค์ที่ข้างต้น
                     <br /><br />กรณีตรวจรักษาผ่านระบบทางไกล (Telemedicine) มีความประสงค์จะเข้าร่วมรับบริการตรวจรักษาผ่านระบบทางไกล(Telemedicine) การรับยาต่อเนื่องและจัดส่งยาทางไปรษณีย์โดยมีรายละเอียดค่าบริการดังนี้
                     <br />1. ค่าดำเนินการและการจัดส่งยาทางไปรษณีย์  90 บาท สำหรับผู้ป่วยทุกสิทธิ ยกเว้นสิทธิประกันสุขภาพถ้วนหน้า ชำระ 40 บาท
                     <br />2. ค่าใช้จ่ายอื่นๆ เช่น ค่าบริการทางการแพทย์ ค่ายานอกบัญชี และเวชภัณฑ์อื่นๆ ที่เบิกไม่ได้  <br />

                        <br /><br />ข้าพเจ้ามีสิทธิที่จะบอกเลิกการยินยอม เมื่อใดก็ได้ ทั้งนี้ การยินยอมหรือไม่ยินยอม และการบอกดังกล่าว จะไม่มีผลต่อการรักษาโรคที่ข้าพเจ้าพึงได้รับต่อไป โดยการบอกเลิกจะมีผลต่อการผลิตสื่อในครั้งหน้า และไม่มีผลต่อสื่อที่ทำไปแล้วก่อนที่จะได้รับหนังสือบอกเลิกการยินยอม
                     <br />
                        {/*
                      มีความประสงค์จะเข้าร่วมรับบริการส่งยาทางไปรษณีย์  โดยมีรายละเอียดดังนี้<br />
                      1. การตรวจรักษาระบบทางไกล (Telemedicine) ให้สถานพยาบาล จัดเก็บ/เปิดเผยข้อมูล/ส่งข้อมูล ทางอิเล็กทรอนิกส์เพื่อการรักษาพยาบาล  <br />
                      2. ค่าดำเนินการและการจัดส่งยาทางไปรษณีย์  90 บาท สำหรับผู้ป่วยทุกสิทธิ ยกเว้นสิทธิประกันสุขภาพถ้วนหน้า ชำระ 40 บาท <br /> 
                      3. ค่าใช้จ่ายอื่นๆ เช่น ค่าบริการทางการแพทย์ ค่ายานอกบัญชี และเวชภัณฑ์อื่นๆ ที่เบิกไม่ได้  <br />
                     */}
                        <br /><br />ข้าพเจ้าอ่านและเข้าใจ จึงยอมรับเงื่อนไขของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ข้าพเจ้าจึงลงนามยินยอม
  
                  </p>
                    <div style={{
                        border: 'solid black 1px', margin: '0 -25px 0 -25px', display: (showSign ? "block" : "none")
                    }} >
                        <canvas id="signature-pad" className="signature-pad" width={clientWidth - 3} height={250}></canvas>
                    </div>

                </ModalBody>
                <div className="modal-footer">
                    <Button color="danger" type="button" onClick={() => setModalConsent(false)}>
                        ไม่ยินยอม
                  </Button>

                    <Button color="danger" color="warning" type="button" onClick={handleClear} style={{ display: (showSign ? "block" : "none") }} >
                        เซ็นใหม่
                  </Button>

                    <Button
                        color="info"
                        type="button"
                        //onClick={handleSign}
                        onClick={() => setShowSign(true)}
                        style={{ display: (!showSign ? "block" : "none") }}
                    >
                        เซ็นชื่อ
                  </Button>
                    <Button
                        color="info"
                        type="button"
                        //onClick={() => setModalConsent(false)}
                        //onClick={handleConfirm}
                        onClick={() => setModal2(true)}
                        style={{ display: (showSign ? "block" : "none") }}
                    >
                        ยินยอม
                  </Button>
                </div>
            </Modal>

            {/* Confirm */}
            <Modal
                modalClassName="modal-mini modal-info"
                toggle={() => setModal2(false)}
                isOpen={modal2}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody>

                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}</p>
                    <p>  </p>
                </ModalBody>
                    <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModal2(false)}
                    >
                        ยกเลิก
                                      </Button>

                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={handleConfirm}
                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    //onClick={() => setModal2(false)}
                    >
                        ยืนยัน
                                      </Button>



                </div>
            </Modal>

            {/* Error */}
            <Modal
                modalClassName="modal-mini modal-danger"
                toggle={() => setModalError(false)}
                isOpen={modalError}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody>
                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                    <p> {errMsg} </p>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                    <Button
                        className="btn-neutral"
                        color="neutral"
                        type="button"
                        onClick={() => setModalError(false)}
                    >
                        ตกลง
                                      </Button>
                </div>
            </Modal>
            <div className="wrapper">
                <div className="section" style={{ padding: 0 }}>
                    <Container>

                        {(isMerge && !isCompleteData) ?
                            <>
                                <h3 className="title" style={{
                                    fontSize: '1.2em', backgroundColor: '#f2f2f2'
                                }}>ยินดีต้อนรับ {FullName}</h3>

                                <div className="send-button">
                                    <Button
                                        block
                                        className="btn-round"
                                        color="success"
                                        href="#"
                                        size="md"
                                        style={{ fontSize: '1.2em' }}
                                        onClick={window.location.href = "https://lin.ee/m6KSajs"}
                                    >
                                        เข้าสู่ Line @trangskin
                                    </Button>

                                    <Button
                                        block
                                        className="btn-round"
                                        color="danger"
                                        href="#"
                                        size="md"
                                        style={{ fontSize: '1.2em' }}
                                        onClick={window.location.href = "https://liff.line.me/1654063801-PwXBy90W"}
                                    >
                                        กรอกประวัติเพิ่มเติม
                                    </Button>
                                </div>
                            </>
                            :
                            <>
                                <h3 className="title" style={{
                                    fontSize: '1.2em', backgroundColor: '#f2f2f2'
                                }}>ยืนยันตัวตน Line @Trangskin</h3>
                                <div>HN {hn}</div>
                                {/*
                            <div>ID {LineTrangskin}</div>
                           
                        */}

                                <div className="send-button">
                                    <Button
                                        block
                                        hidden={(LineTrangskin == null || LineTrangskin == '')}
                                        className="btn-round"
                                        color="success"
                                        href="#"
                                        size="md"
                                        style={{ fontSize: '1.2em' }}
                                        onClick={handleSubmit}
                                    >
                                        ยืนยัน
                                    </Button>

                                    <Button
                                        block
                                        className="btn-round"
                                        color="danger"
                                        href="#"
                                        size="md"
                                        style={{ fontSize: '1.2em' }}
                                    //onClick={e => setLineTrangskin('11111')}
                                    //onClick={liff.closeWindow()}
                                    >
                                        ยกเลิก
                                    </Button>
                                </div>
                            </>
                        }
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default MergeHN;
